import { EAnalyticsEvents } from '@/_analytic/_types';
import { sendAnalyticsEvent } from '@/_analytic/send-analytics-event';
import { TSearchStartTypingEventParams } from './_types';

export const searchStartTypingEvent = (
  params: TSearchStartTypingEventParams,
) => {
  sendAnalyticsEvent({
    name: EAnalyticsEvents.SEARCH_START_TYPING,
    params,
  });
};
